module.exports = __webpack_public_path__ + "img/WechatIMG135.jpeg";